import { ButtonPosition } from '@/common/manager/position/button-position';
export const config = {
    value: 'setFormStepCurrent',
    position: [ButtonPosition.formEvent],
};
